export const SERVICE_NAME_HEADER = 'travel-service-name';
export const DEVICE_NAME_HEADER = 'travel-device-name';
